import { render, staticRenderFns } from "./show.vue?vue&type=template&id=9b76ed34&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b76ed34')) {
      api.createRecord('9b76ed34', component.options)
    } else {
      api.reload('9b76ed34', component.options)
    }
    module.hot.accept("./show.vue?vue&type=template&id=9b76ed34&", function () {
      api.rerender('9b76ed34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/beneficiary/show.vue"
export default component.exports